<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/graphic-2.png" alt="graphic-not-authorized" class="mx-auto mb-4">
            <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">Aguarde um momento!</h1>
            <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-dark">Em alguns segundos você será redirecionado.</p>
            <vs-button size="large" to="/">Voltar</vs-button>
        </div>
    </div>
</template>

<script>

import moduleInstance from '@/store/instance/moduleInstance'

export default {
    name: "redirect",
    methods: {
        async handleUrlParameters() {
            const params = window.location.search;
            const channels = this.getUrlParameter(params, "channels");
            const instanceId = this.getUrlParameter(params, "instance_id");

            if ( channels && instanceId ) {
                const channelId = channels.substring(1, channels.length - 1).split(",")[0];

                let instance = {
                    id: instanceId,
                    activated: false,
                    dialog_params: { channel_id: channelId }
                };

                await this.$store.dispatch("instance/update", instance)
                    .then(() => { if (window.opener) { window.close(); } })
                    .catch((error) => {
                        console.error(error)
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Problemas ao salvar!',
                            text: `Ocorreu um erro interno ao atualizar a conexão.`,
                            time: 7000
                        })
                    })
            }
        },
        getUrlParameter(params, name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            const results = regex.exec(params);
            return results !== null ? decodeURIComponent(results[1].replace(/\+/g, " ")) : "";
        }
    },
    async mounted() {
        if ( !moduleInstance.isRegistered ) {
            this.$store.registerModule('instance', moduleInstance)
            moduleInstance.isRegistered = true
        }
        await this.handleUrlParameters()
    }
}

</script>